import { MoneyValueEntity } from 'lemunzo-api';

/**
 * For the provided nullable entity, returns a formatted currency string.
 * @param value the value to be formatted to human-readable form
 * @returns the formatted currency string or a default value if null or undefined
 */
export function formatCurrency(value: MoneyValueEntity | null): string {
    return value?.value && value.currency !== ''
        ? `${value.value} ${value.currency}`
        : 'N/A';
}
